import { InnerBlocks } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";

const TwoColumns = {
  title: __('Two column content'),
  description: __('Two column content block for the ABS theme'),
  icon: 'media-document',
  attributes: {},
  edit({ className }) {

    const ALLOWED_BLOCKS = [ 'core/image', 'core/paragraph', 'core/list', 'core/button' ];
    const MY_TEMPLATE = [
      [ 'core/columns', { className: 'row' }, [
        [ 'core/column', { className: 'col-sm-6' }, [
            [ 'core/heading', { placeholder: __('Column Title') } ],
            [ 'core/paragraph', { placeholder: __('Column Content') } ],
          ]
        ],
        [ 'core/column', { className: 'col-sm-6' }, [
            [ 'core/heading', { placeholder: __('Column Title') } ],
            [ 'core/paragraph', { placeholder: __('Column Content') } ],
          ]
        ]
      ]],
    ];

    return (
        <div className={className}>
          <div className="container">
            <InnerBlocks
              template={ MY_TEMPLATE }
              allowedBlocks={ ALLOWED_BLOCKS }
            />
          </div>
        </div>
    );
  },

  save({ className }) {
    return (
      <div className={className}>
        <div className="container">
          <InnerBlocks.Content />
        </div>
      </div>
    );
  },
};

export default TwoColumns;
